import React from 'react';
import { ShippingAddressCard as ShippingAddress } from '@thd-olt-component-react/shipping-address-card';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
export var ShippingAddressCard = function () { return (React.createElement(ErrorBoundary, { name: "shipping-address" },
    React.createElement(ShippingAddress, null))); };
